import { render, staticRenderFns } from "./QuizPage.vue?vue&type=template&id=35bdb2fa&scoped=true"
import script from "./QuizPage.vue?vue&type=script&lang=js"
export * from "./QuizPage.vue?vue&type=script&lang=js"
import style0 from "./QuizPage.vue?vue&type=style&index=0&id=35bdb2fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bdb2fa",
  null
  
)

export default component.exports